import { Component, OnInit } from '@angular/core';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-payment-management',
  templateUrl: './payment-management.component.html',
  styleUrls: ['./payment-management.component.scss']
})

export class PaymentManagementComponent implements OnInit {

  constructor(
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setSEO('รายการทางการเงิน', 'website', '');
  }

}
